import {Component} from 'react';
import React from 'react';
import Menu from '../Menu.js'
import Loading from '../Loading.js';
import { Redirect } from 'react-router';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {apiService} from '../../common/apiCallService';
import {baseUrl} from '../../common/config.js';
import validator from 'validator';
import Snackbar from 'material-ui/Snackbar'
import {Link} from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'

class NewPromotionalContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id : '',
      menu_title : '',
      dataValid : false,
      title  : '',
      title_error : '',
      min_range : '',
      min_range_error : '',
      max_range : '',
      max_range_error : '',
      webLink : '',
      webLink_error : '',
      imageLink : '',
      imageLink_error : '',
      content : '',
      content_error : '',
      isDataValid : true,
      showErr : false,
      errorMsg : ''
    }

    if(props.match.params.id) {
      this.state._id = props.match.params.id
      this.state.menu_title = 'Update Promotional Content'
    } else {
      this.state.menu_title = 'New Promotional Content'
    }

  }

  validate = () => {
    this.setState({title_error : '',
      min_range_error : '',
      max_range_error : '',
      webLink_error : '',
      imageLink_error : '',
      content_error : '',
      isDataValid : true
    })

    let {_id, title, min_range, max_range, webLink, imageLink, content} = this.state;

    title = title.trim();
    min_range = parseFloat(min_range);
    max_range = parseFloat(max_range);
    content = content.trim();
    webLink = webLink.trim();
    imageLink = imageLink.trim();

    if(validator.isEmpty(title)) this.setState({title_error:"Title cannot be emty", isDataValid:false})

    if(isNaN(min_range)) this.setState({min_range_error:"Please enter a valid range", isDataValid:false})
    if(min_range > 100) this.setState({min_range_error:"Minimum range cannot be greater than 100", isDataValid:false})

    if(isNaN(max_range)) this.setState({max_range_error:"Please enter a valid range", isDataValid:false})
    if(max_range > 100) this.setState({max_range_error:"Minimum range cannot be greater than 100", isDataValid:false})

    if(min_range >= max_range) this.setState({
      min_range_error : 'The Minimum Range cannot be greater than Max Range',
      max_range_error : 'The Max Range cannot be less than Min Range',
      isDataValid : false
    })


    if(validator.isEmpty(content)) this.setState({content_error:"content cannot be emty", isDataValid:false})

    if(validator.isEmpty(webLink)) this.setState({webLink_error:"weblink cannot be emty", isDataValid:false})
    if(!validator.isURL(webLink)) this.setState({webLink_error:"Please provide a link", isDataValid:false})

    if(validator.isEmpty(imageLink)) this.setState({imageLink_error:"weblink cannot be emty", isDataValid:false})
    if(!validator.isURL(imageLink)) this.setState({imageLink_error:"Please provide a link", isDataValid:false})


    setTimeout(() => {
      if(this.state.isDataValid) {
        if(this.state._id) this.updateContent({_id, title, min_range, max_range, webLink, content,imageLink})
        else this.saveContent({title, min_range, max_range, webLink, content, imageLink})
      }
    })
  }

  saveContent = (user) => {
    apiService(baseUrl + '/promotionalContent/create', user,
    (data) => {
      this.setState({
        exitDialog : true,
        exitmsg : "Promotional Content Added"
      })
    },
    (data) => {
      this.setState({
        showErr : true,
        errorMsg : "this range cannot be used"
      })
    })
  }

  updateContent = (user) => {
    apiService(
      baseUrl + '/promotionalContent/update',
      user,
      (data) => {
        this.setState({
          exitDialog : true,
          exitmsg : "Promotional Content Updated"
        })

      },
      (data) => {
        this.setState({
          showErr : true,
          errorMsg : "This range cannot be used"
        })
      })
  }

  setContent = (id) => {
    apiService(baseUrl + '/promotionalContent/details', {id:this.state._id},
    (data) => {
      this.setState(data);
    },
    (data) => {
      this.setState({loginRedirect : true})
    })
  }

  componentDidMount() {
    createVirtualPageLoad("/promotionalContent")
     if(this.state._id) this.setContent(this.state._id);
   }

  componentWillUnmount() {
    closeVirtualPage()
  }

  render() {
    this.props.setHeaderTitle(this.state.menu_title)
    const actions = [
      <FlatButton
        label="OK"
        data-e2e="ok"
        primary={true}
        onClick={() => {this.setState({onSubmit : true, exitDialog:false})}}
      />
    ];
    return(
      <div>
        {this.state.loading ? <Loading/> : null}
        {this.state.loginRedirect && (<Redirect to={'/'}/>)}
        {this.state.onSubmit && (<Redirect to={'/promotionalContent/list'}/>)}
        <Snackbar  open={this.state.showErr}   message={this.state.errorMsg} autoHideDuration={8000}  bodyStyle={{color: 'red'}} />
        <Dialog
          actions={actions}
          modal={false}
          open={this.state.exitDialog}
          onRequestClose={() => {this.setState({onSubmit : true, exitDialog:false})}}
        >
        {this.state.exitmsg}
        </Dialog>
        <div className="container">
          <center>
            <Paper zDepth={5} style={{marginTop:'40',marginBottom:'40', textAlign: 'center',display: 'inline-block', padding: 40}}>
            <TextField
              hintText="Enter Title"
              floatingLabelText="Title"
              data-e2e="title"
              value = {this.state.title}
              errorText = {this.state.title_error}
              onChange = {(event,newValue) => this.setState({title:newValue})}
             /><br/>
             <TextField
               hintText="Minimum Range"
               data-e2e="Minimum Range"
               floatingLabelText="Minimum Range"
               value = {this.state.min_range}
               errorText = {this.state.min_range_error}
               onChange = {(event,newValue) => this.setState({min_range:newValue})}
              /><br/>
             <TextField
               hintText="Maximum Range"
               data-e2e="Max Range"
               floatingLabelText="Max Range"
               value = {this.state.max_range}
               errorText = {this.state.max_range_error}
               onChange = {(event,newValue) => this.setState({max_range:newValue})}
              /><br/>

             <textarea
               style={{height: '200', width:'100%',backgroundColor:'#2D2C34',border:'none',color:'white',padding:'16px'}}
               placeholder="Content"
               data-e2e="text area"
               value = {this.state.content}
               errorText = {this.state.content_error}
               multiLine={true}
               rows={1}
               rowMax={4}
               onChange = {(event,newValue) => {
                 this.setState({content:event.target.value})
               }}
              /><br/>
              <span style={{color:"red"}}>{this.state.content_error}</span><br/>
              <TextField
                floatingLabelText="Image URL"
                data-e2e="image url"
                hintText="Image URL"
                value = {this.state.imageLink}
                errorText = {this.state.imageLink_error}
                onChange = {(event,newValue) => this.setState({imageLink:newValue})}
               /><br/>
              <TextField
                floatingLabelText="Web Link"
                hintText="Web Link"
                data-e2e="web link"
                value = {this.state.webLink}
                errorText = {this.state.webLink_error}
                onChange = {(event,newValue) => this.setState({webLink:newValue})}
               /><br/>
               <div className="row">
                  <div className="col-xs-6">
                  {this.state._id ?
                    <RaisedButton label="UPDATE" data-e2e="update" primary={true} onClick={(event) => this.validate(event)}/>
                    :<RaisedButton label="SUBMIT" data-e2e="submit" primary={true} onClick={(event) => this.validate(event)}/>
                  }
                  </div>
                  <div className="col-xs-6">
                    <Link  style={{textDecoration:"none"}}  to={'/promotionalContent/list'}>
                      <RaisedButton label="CANCEL" data-e2e="cancel"/>
                    </Link>
                  </div>
               </div>
            </Paper>
          </center>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(null, mapDispatchToProps)(NewPromotionalContent);



/** WEBPACK FOOTER **
 ** ./src/components/PromotionalContent/NewPromotionalContent.js
 **/